import { Range } from './range.model';


export class Table<T> {
    constructor(
        public range: Range,
        public containsData: boolean,
        protected cache: T) { }
}
